export var IconName;
(function (IconName) {
    IconName["UI_4G_4G_PLUS"] = "tri-4g-4g-plus";
    IconName["UI_4G_5G"] = "tri-4g-5g";
    IconName["UI_4G_PLUS"] = "tri-4g-plus";
    IconName["UI_4G"] = "tri-4g";
    IconName["UI_5G_4G_PLUS"] = "tri-5g-4g-plus";
    IconName["UI_5G"] = "tri-5g";
    IconName["ACCESSORIES"] = "tri-accessories";
    IconName["ACCOMODATION"] = "tri-accomodation";
    IconName["ADVISOR"] = "tri-advisor";
    IconName["AFRICA"] = "tri-africa";
    IconName["AIR_TRAVEL"] = "tri-air-travel";
    IconName["ALERT"] = "tri-alert";
    IconName["ANONYMOUS_MODE"] = "tri-anonymous-mode";
    IconName["APPLICATIONRDR"] = "tri-applicationrdr";
    IconName["ARCHIVING_FOLDER"] = "tri-archiving-folder";
    IconName["ARCHIVING"] = "tri-archiving";
    IconName["ARROW_BOTTOM"] = "tri-arrow-bottom";
    IconName["ARROW_DOWN"] = "tri-arrow-down";
    IconName["ARROW_HIGH"] = "tri-arrow-high";
    IconName["ARROW_LEFT"] = "tri-arrow-left";
    IconName["ARROW_RIGHT"] = "tri-arrow-right";
    IconName["ARROW_UP"] = "tri-arrow-up";
    IconName["ARTIFICIAL_INTELLIGENCE"] = "tri-artificial-intelligence";
    IconName["ARTIST_CHAIR"] = "tri-artist-chair";
    IconName["AT_CHECK"] = "tri-at-check";
    IconName["AT_COGS_CIRCLE"] = "tri-at-cogs-circle";
    IconName["AT_EXCLAMATION_CIRCLE"] = "tri-at-exclamation-circle";
    IconName["AT_GLOBE"] = "tri-at-globe";
    IconName["AT_INFINITY_CIRCLE"] = "tri-at-infinity-circle";
    IconName["AT_INFOS"] = "tri-at-infos";
    IconName["AT_PLUS_CIRCLE"] = "tri-at-plus-circle";
    IconName["AT_RETIREMENT"] = "tri-at-retirement";
    IconName["AT_UNAVAILABLE"] = "tri-at-unavailable";
    IconName["AT_UNVAILABLE"] = "tri-at-unvailable";
    IconName["AT"] = "tri-at";
    IconName["AUTOPLAN"] = "tri-autoplan";
    IconName["BABYPHONE"] = "tri-babyphone";
    IconName["BADGES"] = "tri-badges";
    IconName["BANK"] = "tri-bank";
    IconName["BARCODE_SEARCH"] = "tri-barcode-search";
    IconName["BARRIERS_ENGAGEMENT"] = "tri-barriers-engagement";
    IconName["BASKETBALL"] = "tri-basketball";
    IconName["BATTERY"] = "tri-battery";
    IconName["BDUO"] = "tri-bduo";
    IconName["BEACH"] = "tri-beach";
    IconName["BEAUTICIAN"] = "tri-beautician";
    IconName["BEETY"] = "tri-beety";
    IconName["BELL_RINGING"] = "tri-bell-ringing";
    IconName["BELL"] = "tri-bell";
    IconName["BIRTHDAY"] = "tri-birthday";
    IconName["BLUETOOTH"] = "tri-bluetooth";
    IconName["BOX_4G"] = "tri-box-4g";
    IconName["BOX_ADD"] = "tri-box-add";
    IconName["BOX_CHECK"] = "tri-box-check";
    IconName["BOX_COGS"] = "tri-box-cogs";
    IconName["BOX_EOLE_2"] = "tri-box-eole-2";
    IconName["BOX_EOLE_TV"] = "tri-box-eole-tv";
    IconName["BOX_EOLE"] = "tri-box-eole";
    IconName["BOX_EXCLAMATION"] = "tri-box-exclamation";
    IconName["BOX_FAQ"] = "tri-box-faq";
    IconName["BOX_MOBILE"] = "tri-box-mobile";
    IconName["BOX_RADIO"] = "tri-box-radio";
    IconName["BOX_REDO"] = "tri-box-redo";
    IconName["BOX_SMARTTV"] = "tri-box-smarttv";
    IconName["BOX_STETHOSCOPE"] = "tri-box-stethoscope";
    IconName["BOX_UNAVAILABLE"] = "tri-box-unavailable";
    IconName["BOX_UNAVALAIBLE"] = "tri-box-unavalaible";
    IconName["BOX_WIFI_6_PLUS_SIM_CARDS"] = "tri-box-wifi-6-plus-sim-cards";
    IconName["BOX_WIFI_6_TV"] = "tri-box-wifi-6-tv";
    IconName["BOX_WIFI_6"] = "tri-box-wifi-6";
    IconName["BOX"] = "tri-box";
    IconName["BTV_ILLIMITE"] = "tri-btv-illimite";
    IconName["BTV"] = "tri-btv";
    IconName["BTVPLUS"] = "tri-btvplus";
    IconName["BUILDING_2"] = "tri-building-2";
    IconName["BUILDING"] = "tri-building";
    IconName["BUSINESS_TRIP"] = "tri-business-trip";
    IconName["CAID_CAPRI"] = "tri-caid-capri";
    IconName["CALENDAR_CHECK"] = "tri-calendar-check";
    IconName["CALENDAR_CLOCK_CIRCLE"] = "tri-calendar-clock-circle";
    IconName["CALENDAR_COGS_CIRCLE"] = "tri-calendar-cogs-circle";
    IconName["CALENDAR_EXCLAMATION_CIRCLE"] = "tri-calendar-exclamation-circle";
    IconName["CALENDAR_INFO_CIRCLE"] = "tri-calendar-info-circle";
    IconName["CALENDAR_PLUS"] = "tri-calendar-plus";
    IconName["CALENDAR_QUESTION_CIRCLE"] = "tri-calendar-question-circle";
    IconName["CALENDAR_UNAVAILABLE"] = "tri-calendar-unavailable";
    IconName["CALENDAR"] = "tri-calendar";
    IconName["CAMERA"] = "tri-camera";
    IconName["CAR_AUTO"] = "tri-car-auto";
    IconName["CAR_POOLING"] = "tri-car-pooling";
    IconName["CAR_RENT"] = "tri-car-rent";
    IconName["CAREER_COMMITTEES"] = "tri-career-committees";
    IconName["CATERING"] = "tri-catering";
    IconName["CERTIFICATION"] = "tri-certification";
    IconName["CHAT_IA"] = "tri-chat-ia";
    IconName["CHAT"] = "tri-chat";
    IconName["CHECK_CIRCLE"] = "tri-check-circle";
    IconName["CHECK_DOUBLE"] = "tri-check-double";
    IconName["CHECK"] = "tri-check";
    IconName["CHILDREN_ACCESS"] = "tri-children-access";
    IconName["CHIMNEY_ANTENNA"] = "tri-chimney-antenna";
    IconName["CHIP"] = "tri-chip";
    IconName["CHRISTMAS_SLEIGH"] = "tri-christmas-sleigh";
    IconName["CHRISTMAS_SOCKS"] = "tri-christmas-socks";
    IconName["CHRISTMAS_TREE"] = "tri-christmas-tree";
    IconName["CITY_HALL"] = "tri-city-hall";
    IconName["CLAPPERBOARD"] = "tri-clapperboard";
    IconName["CLEAN_SURFACE"] = "tri-clean-surface";
    IconName["CLICK_COLLECT_2H"] = "tri-click-collect-2h";
    IconName["CLIPBOARD_CHECKLIST"] = "tri-clipboard-checklist";
    IconName["CLOCK"] = "tri-clock";
    IconName["CLOSED"] = "tri-closed";
    IconName["CLOUD_100GO"] = "tri-cloud-100go";
    IconName["CLOUD_20GO"] = "tri-cloud-20go";
    IconName["CLOUD_30GO"] = "tri-cloud-30go";
    IconName["CLOUD_50GO"] = "tri-cloud-50go";
    IconName["CLOUD_70GO"] = "tri-cloud-70go";
    IconName["CLOUD_CHECK"] = "tri-cloud-check";
    IconName["CLOUD_COGS_CIRCLE"] = "tri-cloud-cogs-circle";
    IconName["CLOUD_EXCLAMATION_CIRCLE"] = "tri-cloud-exclamation-circle";
    IconName["CLOUD_GLOBE"] = "tri-cloud-globe";
    IconName["CLOUD_INFINITY"] = "tri-cloud-infinity";
    IconName["CLOUD_PLUS_CIRCLE"] = "tri-cloud-plus-circle";
    IconName["CLOUD_SAVE"] = "tri-cloud-save";
    IconName["CLOUD"] = "tri-cloud";
    IconName["CO2_EMISSION"] = "tri-co2-emission";
    IconName["CO2_RESEARCH"] = "tri-co2-research";
    IconName["COGS"] = "tri-cogs";
    IconName["COLLABORATIVE_LIBRARY"] = "tri-collaborative-library";
    IconName["COMMENT_EARTH"] = "tri-comment-earth";
    IconName["COMMENT_EXCLAMATION_CIRCLE"] = "tri-comment-exclamation-circle";
    IconName["COMMENT_EYE"] = "tri-comment-eye";
    IconName["COMMENT_INFO"] = "tri-comment-info";
    IconName["COMMENT_QUESTION"] = "tri-comment-question";
    IconName["COMMENT_VOICEMAIL"] = "tri-comment-voicemail";
    IconName["COMMENT"] = "tri-comment";
    IconName["COMMENTS_QUESTION_DOTS"] = "tri-comments-question-dots";
    IconName["COMMUNITY"] = "tri-community";
    IconName["CONCIERGE"] = "tri-concierge";
    IconName["CONNECTED_WATCH"] = "tri-connected-watch";
    IconName["CONTACT"] = "tri-contact";
    IconName["CONTACTLESS_PAYMENT"] = "tri-contactless-payment";
    IconName["COOPTATION"] = "tri-cooptation";
    IconName["COPY"] = "tri-copy";
    IconName["CORPORATE_CARD"] = "tri-corporate-card";
    IconName["COUNTRYSIDE"] = "tri-countryside";
    IconName["COURIER"] = "tri-courier";
    IconName["CREDIT_CARD_ACCEPTED"] = "tri-credit-card-accepted";
    IconName["CREDIT_CARD_LOCK"] = "tri-credit-card-lock";
    IconName["CREDIT_CARD"] = "tri-credit-card";
    IconName["CREDIT_CARDS_12"] = "tri-credit-cards-12";
    IconName["CREDIT_CARDS_24"] = "tri-credit-cards-24";
    IconName["CREDIT_CARDS"] = "tri-credit-cards";
    IconName["CRIPPLING_DISEASE"] = "tri-crippling-disease";
    IconName["CSE"] = "tri-cse";
    IconName["CURSOR"] = "tri-cursor";
    IconName["DAY_DONATIONS"] = "tri-day-donations";
    IconName["DEGREE"] = "tri-degree";
    IconName["DESKTOP"] = "tri-desktop";
    IconName["DIAGNOSTIC"] = "tri-diagnostic";
    IconName["DISLIKE"] = "tri-dislike";
    IconName["DISTANCE_1M"] = "tri-distance-1m";
    IconName["DISTANCE_2M"] = "tri-distance-2m";
    IconName["DONT_TOUCH"] = "tri-dont-touch";
    IconName["DOWNLOAD"] = "tri-download";
    IconName["DUPLICATA"] = "tri-duplicata";
    IconName["E_DP"] = "tri-e-dp";
    IconName["EAR_SLASH"] = "tri-ear-slash";
    IconName["EARTH"] = "tri-earth";
    IconName["ECO_CONCEPTION"] = "tri-eco-conception";
    IconName["ECOMMERCE_PROMO_LABEL"] = "tri-ecommerce-promo-label";
    IconName["ECORESPONSIBLE_DIGITAL"] = "tri-ecoresponsible-digital";
    IconName["ELECTRIC_CAR"] = "tri-electric-car";
    IconName["ELECTRICAL_OVERLOAD"] = "tri-electrical-overload";
    IconName["ELECTRICAL_PLUG"] = "tri-electrical-plug";
    IconName["ENERGY_OPTIMIZATION"] = "tri-energy-optimization";
    IconName["ENERGY"] = "tri-energy";
    IconName["ENTERTAINMENT"] = "tri-entertainment";
    IconName["ENVELOPE_ATTACHMENT"] = "tri-envelope-attachment";
    IconName["ENVELOPE_PLUS_CIRCLE"] = "tri-envelope-plus-circle";
    IconName["ENVELOPE"] = "tri-envelope";
    IconName["ENVIRONMENTAL_FOOTPRINT"] = "tri-environmental-footprint";
    IconName["EQUAL_CIRCLE"] = "tri-equal-circle";
    IconName["EQUAL"] = "tri-equal";
    IconName["ESIM_CHECK"] = "tri-esim-check";
    IconName["ESIM_DOWNLOAD"] = "tri-esim-download";
    IconName["ESIM_UNAVAILABLE"] = "tri-esim-unavailable";
    IconName["ESIM"] = "tri-esim";
    IconName["ETHERNET_FEMALE"] = "tri-ethernet-female";
    IconName["ETHERNET_MALE"] = "tri-ethernet-male";
    IconName["ETHERNET"] = "tri-ethernet";
    IconName["ETHICS"] = "tri-ethics";
    IconName["EUROPE"] = "tri-europe";
    IconName["EUROS"] = "tri-euros";
    IconName["EXCLAMATION_CIRCLE"] = "tri-exclamation-circle";
    IconName["EXCLAMATION_REDO"] = "tri-exclamation-redo";
    IconName["EXCLAMATION"] = "tri-exclamation";
    IconName["EXPENSE_REPORTS"] = "tri-expense-reports";
    IconName["EYE_SLASH"] = "tri-eye-slash";
    IconName["EYE"] = "tri-eye";
    IconName["FACEBOOK"] = "tri-facebook";
    IconName["FACEID"] = "tri-faceid";
    IconName["FACEMASK_1"] = "tri-facemask-1";
    IconName["FACEMASK_2"] = "tri-facemask-2";
    IconName["FACTORY"] = "tri-factory";
    IconName["FILE_ATTACHED"] = "tri-file-attached";
    IconName["FILE_EURO_CHECK_CIRCLE"] = "tri-file-euro-check-circle";
    IconName["FILE_EURO_EXCLAMATION_CIRCLE"] = "tri-file-euro-exclamation-circle";
    IconName["FILE_EURO_INFO_CIRCLE"] = "tri-file-euro-info-circle";
    IconName["FILE_EURO_LOCK_CIRCLE"] = "tri-file-euro-lock-circle";
    IconName["FILE_EURO_QUESTION_CIRCLE"] = "tri-file-euro-question-circle";
    IconName["FILE_EURO"] = "tri-file-euro";
    IconName["FILE_LIST"] = "tri-file-list";
    IconName["FILE_MANAGEMENT"] = "tri-file-management";
    IconName["FILE_NEW"] = "tri-file-new";
    IconName["FILE_PDF"] = "tri-file-pdf";
    IconName["FILM"] = "tri-film";
    IconName["FINGERPRINT"] = "tri-fingerprint";
    IconName["FIRST_AID_CHECK"] = "tri-first-aid-check";
    IconName["FIRST_AID"] = "tri-first-aid";
    IconName["FLASH_SELL"] = "tri-flash-sell";
    IconName["FLEXYMOOV_BICYCLE"] = "tri-flexymoov-bicycle";
    IconName["FLOWER_ORDER"] = "tri-flower-order";
    IconName["FOLDER"] = "tri-folder";
    IconName["FOOTBALL"] = "tri-football";
    IconName["FRANCE_MARKER"] = "tri-france-marker";
    IconName["FRANCE"] = "tri-france";
    IconName["FROWN"] = "tri-frown";
    IconName["GAMEPAD_ONLINE"] = "tri-gamepad-online";
    IconName["GAMEPAD"] = "tri-gamepad";
    IconName["GAMES_CONSOLE"] = "tri-games-console";
    IconName["GAUGE_COGS_CIRCLE"] = "tri-gauge-cogs-circle";
    IconName["GAUGE_EXCLAMATION_CIRCLE"] = "tri-gauge-exclamation-circle";
    IconName["GAUGE_FULL"] = "tri-gauge-full";
    IconName["GAUGE_HALF"] = "tri-gauge-half";
    IconName["GAUGE_PLUS_CIRCLE"] = "tri-gauge-plus-circle";
    IconName["GAUGE_THREE_QUARTER"] = "tri-gauge-three-quarter";
    IconName["GAUGE"] = "tri-gauge";
    IconName["GDT"] = "tri-gdt";
    IconName["GESTURE_SWIPE"] = "tri-gesture-swipe";
    IconName["GIFT"] = "tri-gift";
    IconName["GOOD_PRACTICES"] = "tri-good-practices";
    IconName["GOOGLE"] = "tri-google";
    IconName["GUITAR"] = "tri-guitar";
    IconName["HAIRDRESSER"] = "tri-hairdresser";
    IconName["HAND_MOBILE"] = "tri-hand-mobile";
    IconName["HAND_TOOLS"] = "tri-hand-tools";
    IconName["HANDBALL"] = "tri-handball";
    IconName["HANDS_HELPING"] = "tri-hands-helping";
    IconName["HANDSFREE"] = "tri-handsfree";
    IconName["HEADPHONES"] = "tri-headphones";
    IconName["HEALTH_INSURANCE"] = "tri-health-insurance";
    IconName["HEART_MESSAGE"] = "tri-heart-message";
    IconName["HEART"] = "tri-heart";
    IconName["HELP_DISABILITY"] = "tri-help-disability";
    IconName["HIERARCHY"] = "tri-hierarchy";
    IconName["HOME_TOOLS"] = "tri-home-tools";
    IconName["HOME"] = "tri-home";
    IconName["HOSPITAL_BUILDING"] = "tri-hospital-building";
    IconName["HOSPITAL"] = "tri-hospital";
    IconName["HOTSPOT"] = "tri-hotspot";
    IconName["HOURGLASS"] = "tri-hourglass";
    IconName["HYDRO_GEL"] = "tri-hydro-gel";
    IconName["IDENTITY"] = "tri-identity";
    IconName["IMMERSIVE_CONTENT_GLASS"] = "tri-immersive-content-glass";
    IconName["IMMERSIVE_CONTENT_PEOPLE"] = "tri-immersive-content-people";
    IconName["INDIVIDUAL_CARD"] = "tri-individual-card";
    IconName["INFOS_CIRCLE"] = "tri-infos-circle";
    IconName["INFOS"] = "tri-infos";
    IconName["INSTAGRAM"] = "tri-instagram";
    IconName["INSTALLER"] = "tri-installer";
    IconName["INTERIM"] = "tri-interim";
    IconName["INTERNAL_FRAUD"] = "tri-internal-fraud";
    IconName["IOT"] = "tri-iot";
    IconName["IP"] = "tri-ip";
    IconName["LAPTOP_TABLET_MOBILE"] = "tri-laptop-tablet-mobile";
    IconName["LAPTOP"] = "tri-laptop";
    IconName["LIGHTBULB_ON"] = "tri-lightbulb-on";
    IconName["LIKE"] = "tri-like";
    IconName["LINES_SPEED"] = "tri-lines-speed";
    IconName["LINK_COPY"] = "tri-link-copy";
    IconName["LINK"] = "tri-link";
    IconName["LINKEDIN"] = "tri-linkedin";
    IconName["LOCK_CHECK_CIRCLE"] = "tri-lock-check-circle";
    IconName["LOCK"] = "tri-lock";
    IconName["LOGO"] = "tri-logo";
    IconName["MABB"] = "tri-mabb";
    IconName["MAIL"] = "tri-mail";
    IconName["MAILBOX_MARKER"] = "tri-mailbox-marker";
    IconName["MAN"] = "tri-man";
    IconName["MAP_MARKER"] = "tri-map-marker";
    IconName["MARKER_SOLID"] = "tri-marker-solid";
    IconName["MARKER"] = "tri-marker";
    IconName["MASSAGE"] = "tri-massage";
    IconName["MENTAL_DISABILITY"] = "tri-mental-disability";
    IconName["MENTAL_HANDICAP"] = "tri-mental-handicap";
    IconName["MENU"] = "tri-menu";
    IconName["MICRO_SIM"] = "tri-micro-sim";
    IconName["MICRO"] = "tri-micro";
    IconName["MICROWAVES"] = "tri-microwaves";
    IconName["MINUS_CIRCLE"] = "tri-minus-circle";
    IconName["MINUS"] = "tri-minus";
    IconName["MOBILE_06_SLASH"] = "tri-mobile-06-slash";
    IconName["MOBILE_07_SLASH"] = "tri-mobile-07-slash";
    IconName["MOBILE_08_SLASH"] = "tri-mobile-08-slash";
    IconName["MOBILE_BAN"] = "tri-mobile-ban";
    IconName["MOBILE_BROKEN"] = "tri-mobile-broken";
    IconName["MOBILE_CLOUD"] = "tri-mobile-cloud";
    IconName["MOBILE_COMMENT"] = "tri-mobile-comment";
    IconName["MOBILE_COVERAGE"] = "tri-mobile-coverage";
    IconName["MOBILE_DATA_TRANSFER"] = "tri-mobile-data-transfer";
    IconName["MOBILE_DIAGNOSTIC"] = "tri-mobile-diagnostic";
    IconName["MOBILE_ESIM_DOWNLOAD"] = "tri-mobile-esim-download";
    IconName["MOBILE_ESIM_TRANSFER"] = "tri-mobile-esim-transfer";
    IconName["MOBILE_EURO"] = "tri-mobile-euro";
    IconName["MOBILE_EYE"] = "tri-mobile-eye";
    IconName["MOBILE_FINANCING"] = "tri-mobile-financing";
    IconName["MOBILE_FRAUDULENT_USE"] = "tri-mobile-fraudulent-use";
    IconName["MOBILE_GLOBE"] = "tri-mobile-globe";
    IconName["MOBILE_HAND"] = "tri-mobile-hand";
    IconName["MOBILE_INFINITY"] = "tri-mobile-infinity";
    IconName["MOBILE_LOCK"] = "tri-mobile-lock";
    IconName["MOBILE_NIGHT_MODE"] = "tri-mobile-night-mode";
    IconName["MOBILE_OXIDISATION"] = "tri-mobile-oxidisation";
    IconName["MOBILE_PERCENTAGE"] = "tri-mobile-percentage";
    IconName["MOBILE_PLUS_SIM_CARDS"] = "tri-mobile-plus-sim-cards";
    IconName["MOBILE_RECONDITIONNED"] = "tri-mobile-reconditionned";
    IconName["MOBILE_RECOVERY"] = "tri-mobile-recovery";
    IconName["MOBILE_SCAN_QR"] = "tri-mobile-scan-qr";
    IconName["MOBILE_STAR"] = "tri-mobile-star";
    IconName["MOBILE_SYNC"] = "tri-mobile-sync";
    IconName["MOBILE_TOOLS"] = "tri-mobile-tools";
    IconName["MOBILE_UP_DOWN"] = "tri-mobile-up-down";
    IconName["MOBILE_YOUTH"] = "tri-mobile-youth";
    IconName["MOBILE"] = "tri-mobile";
    IconName["MOBILITY"] = "tri-mobility";
    IconName["MODEM_3G"] = "tri-modem-3g";
    IconName["MOON"] = "tri-moon";
    IconName["MOTIVATION"] = "tri-motivation";
    IconName["MOUNTAIN"] = "tri-mountain";
    IconName["MOUSE"] = "tri-mouse";
    IconName["MOVING_PERSONS_GOODS"] = "tri-moving-persons-goods";
    IconName["MUG"] = "tri-mug";
    IconName["MYPEOPLEDOC"] = "tri-mypeopledoc";
    IconName["NANO_SIM"] = "tri-nano-sim";
    IconName["NETWORK_ANTENNA"] = "tri-network-antenna";
    IconName["NETWORK"] = "tri-network";
    IconName["NEW_TABBED_PAGE"] = "tri-new-tabbed-page";
    IconName["NEWSPAPERS"] = "tri-newspapers";
    IconName["NOTEBOOK_TARIFS"] = "tri-notebook-tarifs";
    IconName["NOTES"] = "tri-notes";
    IconName["NUCLEAR"] = "tri-nuclear";
    IconName["OFFICE_SUPPLY"] = "tri-office-supply";
    IconName["OMNICHANNEL"] = "tri-omnichannel";
    IconName["OPTICIAN"] = "tri-optician";
    IconName["ORGANIZATION_CHART"] = "tri-organization-chart";
    IconName["PACK_BIG"] = "tri-pack-big";
    IconName["PACKAGE_PREPARATION"] = "tri-package-preparation";
    IconName["PAPER_PLANE"] = "tri-paper-plane";
    IconName["PAPERCLIP"] = "tri-paperclip";
    IconName["PARCEL_RELAY"] = "tri-parcel-relay";
    IconName["PARCEL"] = "tri-parcel";
    IconName["PAUSE"] = "tri-pause";
    IconName["PAY_GAP"] = "tri-pay-gap";
    IconName["PENCIL"] = "tri-pencil";
    IconName["PERSON_DOOR"] = "tri-person-door";
    IconName["PERSONAL_SPACE"] = "tri-personal-space";
    IconName["PHISHING"] = "tri-phishing";
    IconName["PHONE_AFRICA"] = "tri-phone-africa";
    IconName["PHONE_BLOCKED"] = "tri-phone-blocked";
    IconName["PHONE_BURGER"] = "tri-phone-burger";
    IconName["PHONE_EURO"] = "tri-phone-euro";
    IconName["PHONE_EUROPE"] = "tri-phone-europe";
    IconName["PHONE_GLOBE"] = "tri-phone-globe";
    IconName["PHONE_INCOMING_CALL"] = "tri-phone-incoming-call";
    IconName["PHONE_INFINITY"] = "tri-phone-infinity";
    IconName["PHONE_MISSED"] = "tri-phone-missed";
    IconName["PHONE_NOTES"] = "tri-phone-notes";
    IconName["PHONE_OUTGOING_CALL"] = "tri-phone-outgoing-call";
    IconName["PHONE_PLUS_SIM_CARD"] = "tri-phone-plus-sim-card";
    IconName["PHONE_PLUS_SIM_CARDS"] = "tri-phone-plus-sim-cards";
    IconName["PHONE_SWITZERLAND"] = "tri-phone-switzerland";
    IconName["PHONE_WAITING_CALL"] = "tri-phone-waiting-call";
    IconName["PHONE"] = "tri-phone";
    IconName["PHYSICAL_DISABILITY"] = "tri-physical-disability";
    IconName["PINTEREST"] = "tri-pinterest";
    IconName["PLAY_BEGINNING"] = "tri-play-beginning";
    IconName["PLAY"] = "tri-play";
    IconName["PLEXI_EXCHANGE"] = "tri-plexi-exchange";
    IconName["PLUG_CHECK"] = "tri-plug-check";
    IconName["PLUS_CIRCLE"] = "tri-plus-circle";
    IconName["PLUS"] = "tri-plus";
    IconName["PORTAL_EGP"] = "tri-portal-egp";
    IconName["PORTAL_RH"] = "tri-portal-rh";
    IconName["POWER"] = "tri-power";
    IconName["PRESENCE"] = "tri-presence";
    IconName["PRESS_KIT"] = "tri-press-kit";
    IconName["PRINTER"] = "tri-printer";
    IconName["PRINTING_STATIONERY"] = "tri-printing-stationery";
    IconName["PRIORITY_PATH"] = "tri-priority-path";
    IconName["PROMO_LABEL_50"] = "tri-promo-label-50";
    IconName["PROMO_LABEL_60"] = "tri-promo-label-60";
    IconName["PROMO_LABEL_70"] = "tri-promo-label-70";
    IconName["PROMO_LABEL_80"] = "tri-promo-label-80";
    IconName["PROMO_LABEL_90"] = "tri-promo-label-90";
    IconName["PROMOTIONS"] = "tri-promotions";
    IconName["PROVIDENT_HEALTH"] = "tri-provident-health";
    IconName["QR_CODE"] = "tri-qr-code";
    IconName["QUESTION_CIRCLE"] = "tri-question-circle";
    IconName["QUESTION"] = "tri-question";
    IconName["RECRUITMENT_DIFFICULTIES"] = "tri-recruitment-difficulties";
    IconName["RECYCLE"] = "tri-recycle";
    IconName["REDO_14_DAYS"] = "tri-redo-14-days";
    IconName["REDO_30_DAYS"] = "tri-redo-30-days";
    IconName["REDO_7_DAYS"] = "tri-redo-7-days";
    IconName["REDUCE_CO2_EMISSION"] = "tri-reduce-co2-emission";
    IconName["REFRESH"] = "tri-refresh";
    IconName["REMOTE"] = "tri-remote";
    IconName["REPEATER_ALT"] = "tri-repeater-alt";
    IconName["RESTRICTED_AREA"] = "tri-restricted-area";
    IconName["RINGTONE_WELCOMESOUND"] = "tri-ringtone-welcomesound";
    IconName["ROTATION_360"] = "tri-rotation-360";
    IconName["RUGBY"] = "tri-rugby";
    IconName["RULES"] = "tri-rules";
    IconName["SAMPLES_COGS_CIRCLE"] = "tri-samples-cogs-circle";
    IconName["SAMPLES_EXCLAMATION_MARK_CIRCLE"] = "tri-samples-exclamation-mark-circle";
    IconName["SAMPLES_PLUS_CIRCLE"] = "tri-samples-plus-circle";
    IconName["SAMPLES"] = "tri-samples";
    IconName["SANTA_CLAUS"] = "tri-santa-claus";
    IconName["SATELLITE_ANTENNA"] = "tri-satellite-antenna";
    IconName["SAVINGS_ACCOUNT"] = "tri-savings-account";
    IconName["SCAN_QR"] = "tri-scan-qr";
    IconName["SCAN"] = "tri-scan";
    IconName["SD_CARD"] = "tri-sd-card";
    IconName["SEARCH"] = "tri-search";
    IconName["SECURITY_HEALTH"] = "tri-security-health";
    IconName["SEMINARS"] = "tri-seminars";
    IconName["SERVER"] = "tri-server";
    IconName["SHARE"] = "tri-share";
    IconName["SHIELD_AT"] = "tri-shield-at";
    IconName["SHIELD_CHECK"] = "tri-shield-check";
    IconName["SHIELD_EXCLAMATION"] = "tri-shield-exclamation";
    IconName["SHIELD_PRIVATE_LIFE"] = "tri-shield-private-life";
    IconName["SHIELD"] = "tri-shield";
    IconName["SHOOTING_STAR"] = "tri-shooting-star";
    IconName["SHOPPING_BAG"] = "tri-shopping-bag";
    IconName["SHOPPING_CART"] = "tri-shopping-cart";
    IconName["SIM_CARD_BIG"] = "tri-sim-card-big";
    IconName["SIM_CARD_ESIM_TRANSFER"] = "tri-sim-card-esim-transfer";
    IconName["SIM_CARD_LOCK"] = "tri-sim-card-lock";
    IconName["SIM_CARD_PLUS_MOBILE_BIG"] = "tri-sim-card-plus-mobile-big";
    IconName["SIM_CARD_REDO"] = "tri-sim-card-redo";
    IconName["SIM_CARD_UNLOCK"] = "tri-sim-card-unlock";
    IconName["SIM_CARD"] = "tri-sim-card";
    IconName["SIM_CARDS"] = "tri-sim-cards";
    IconName["SLIDERS"] = "tri-sliders";
    IconName["SMILE_NEUTRAL"] = "tri-smile-neutral";
    IconName["SMILE_NOCIRCLED"] = "tri-smile-nocircled";
    IconName["SMILE_PLUS"] = "tri-smile-plus";
    IconName["SMILE"] = "tri-smile";
    IconName["SNAPCHAT"] = "tri-snapchat";
    IconName["SOCIAL_ENGAGEMENT"] = "tri-social-engagement";
    IconName["SOLIDARITY_DAY"] = "tri-solidarity-day";
    IconName["SORT"] = "tri-sort";
    IconName["SPORT_SHIRT"] = "tri-sport-shirt";
    IconName["SPORT"] = "tri-sport";
    IconName["STADIUM"] = "tri-stadium";
    IconName["STAR_EMPTY"] = "tri-star-empty";
    IconName["STAR_FILLED"] = "tri-star-filled";
    IconName["STAR_HALF"] = "tri-star-half";
    IconName["STAR"] = "tri-star";
    IconName["STEERING_WHEEL"] = "tri-steering-wheel";
    IconName["STOPWATCH_CLICK_COLLECT"] = "tri-stopwatch-click-collect";
    IconName["STOPWATCH"] = "tri-stopwatch";
    IconName["STORE_LOCATOR"] = "tri-store-locator";
    IconName["STORE"] = "tri-store";
    IconName["SUBMENU"] = "tri-submenu";
    IconName["SUCCESSION_PLAN"] = "tri-succession-plan";
    IconName["SUN_EURO"] = "tri-sun-euro";
    IconName["SUN"] = "tri-sun";
    IconName["SUNGLASSES"] = "tri-sunglasses";
    IconName["SUSTAINABLE_DEVELOPMENT"] = "tri-sustainable-development";
    IconName["SYNC"] = "tri-sync";
    IconName["SYNCHRO"] = "tri-synchro";
    IconName["TABLET"] = "tri-tablet";
    IconName["TALENTSOFT"] = "tri-talentsoft";
    IconName["TARGET"] = "tri-target";
    IconName["TEAM_MEAL"] = "tri-team-meal";
    IconName["TELECONSULTATION"] = "tri-teleconsultation";
    IconName["TENNIS"] = "tri-tennis";
    IconName["TH"] = "tri-th";
    IconName["THUNDER_REDO"] = "tri-thunder-redo";
    IconName["TIKTOK"] = "tri-tiktok";
    IconName["TIMES_CIRCLE"] = "tri-times-circle";
    IconName["TIMES"] = "tri-times";
    IconName["TOOLS"] = "tri-tools";
    IconName["TOP_NEWS"] = "tri-top-news";
    IconName["TRAIN"] = "tri-train";
    IconName["TRAINING_DIPLOMA"] = "tri-training-diploma";
    IconName["TRANSPORT"] = "tri-transport";
    IconName["TRASH"] = "tri-trash";
    IconName["TRAVEL_AGENCY"] = "tri-travel-agency";
    IconName["TRAVEL_POLICIES"] = "tri-travel-policies";
    IconName["TREE_ANTENNA"] = "tri-tree-antenna";
    IconName["TROMBINOSCOPE"] = "tri-trombinoscope";
    IconName["TRUCK_DAY_AFTER"] = "tri-truck-day-after";
    IconName["TRUCK_GIFT"] = "tri-truck-gift";
    IconName["TRUCK_SPEED"] = "tri-truck-speed";
    IconName["TRUCK"] = "tri-truck";
    IconName["TURKEY"] = "tri-turkey";
    IconName["TV_4K"] = "tri-tv-4k";
    IconName["TV_8K"] = "tri-tv-8k";
    IconName["TV_BTV"] = "tri-tv-btv";
    IconName["TV_CURVED"] = "tri-tv-curved";
    IconName["TV_HD"] = "tri-tv-hd";
    IconName["TV_INFINITY"] = "tri-tv-infinity";
    IconName["TV_MULTI_OPTICAL_FIBER"] = "tri-tv-multi-optical-fiber";
    IconName["TV_MULTI"] = "tri-tv-multi";
    IconName["TV_VOD"] = "tri-tv-vod";
    IconName["TV"] = "tri-tv";
    IconName["TWITCH"] = "tri-twitch";
    IconName["TWITTER"] = "tri-twitter";
    IconName["UNAVAILABLE"] = "tri-unavailable";
    IconName["UNDO"] = "tri-undo";
    IconName["UNLIMITED"] = "tri-unlimited";
    IconName["UPLOAD"] = "tri-upload";
    IconName["USBKEY"] = "tri-usbkey";
    IconName["USER_COMMENT"] = "tri-user-comment";
    IconName["USER_HEADSET"] = "tri-user-headset";
    IconName["USER_HEART"] = "tri-user-heart";
    IconName["USER_KEY"] = "tri-user-key";
    IconName["USER_LEGAL"] = "tri-user-legal";
    IconName["USER_LIGHTBULB"] = "tri-user-lightbulb";
    IconName["USER_LOCK"] = "tri-user-lock";
    IconName["USER_SHIELD"] = "tri-user-shield";
    IconName["USER_TIE"] = "tri-user-tie";
    IconName["USER_UNLOCK"] = "tri-user-unlock";
    IconName["USER"] = "tri-user";
    IconName["USERS_FAMILY"] = "tri-users-family";
    IconName["USERS_SHIELD_STAR"] = "tri-users-shield-star";
    IconName["USERS"] = "tri-users";
    IconName["V_SIGN"] = "tri-v-sign";
    IconName["VACATIONS"] = "tri-vacations";
    IconName["VICTORY"] = "tri-victory";
    IconName["VIDEO_CAMERA"] = "tri-video-camera";
    IconName["VISIO"] = "tri-visio";
    IconName["VISOR"] = "tri-visor";
    IconName["VISUALLY_IMPAIRED"] = "tri-visually-impaired";
    IconName["VOICE_ASSISTANCE"] = "tri-voice-assistance";
    IconName["VOICEMAIL"] = "tri-voicemail";
    IconName["VOLUME_OFF"] = "tri-volume-off";
    IconName["VOLUME_ON"] = "tri-volume-on";
    IconName["VTC_TAXI_MOTORBIKE"] = "tri-vtc-taxi-motorbike";
    IconName["WALL"] = "tri-wall";
    IconName["WASTE_REDUCTION"] = "tri-waste-reduction";
    IconName["WATCH"] = "tri-watch";
    IconName["WATER"] = "tri-water";
    IconName["WEBCAM"] = "tri-webcam";
    IconName["WIDGET"] = "tri-widget";
    IconName["WIFI_5"] = "tri-wifi-5";
    IconName["WIFI_6"] = "tri-wifi-6";
    IconName["WIFI_6E"] = "tri-wifi-6e";
    IconName["WIFI_7"] = "tri-wifi-7";
    IconName["WIFI_CHECK"] = "tri-wifi-check";
    IconName["WIFI_COGS"] = "tri-wifi-cogs";
    IconName["WIFI_LOW"] = "tri-wifi-low";
    IconName["WIFI_MEDIUM"] = "tri-wifi-medium";
    IconName["WIFI_SHARE"] = "tri-wifi-share";
    IconName["WIFI_UNAVAILABLE"] = "tri-wifi-unavailable";
    IconName["WIFI"] = "tri-wifi";
    IconName["WINDMILL"] = "tri-windmill";
    IconName["WINDOWS"] = "tri-windows";
    IconName["WOMAN_MAN"] = "tri-woman-man";
    IconName["WOMAN"] = "tri-woman";
    IconName["WORK_STOPPAGE"] = "tri-work-stoppage";
    IconName["WORKELO"] = "tri-workelo";
    IconName["WORKPLACE_LAYOUT"] = "tri-workplace-layout";
    IconName["WORKSHOP"] = "tri-workshop";
    IconName["X"] = "tri-x";
    IconName["YOUTH"] = "tri-youth";
    IconName["YOUTUBE"] = "tri-youtube";
    IconName["ZOOM_IN"] = "tri-zoom-in";
    IconName["ZOOM_OUT"] = "tri-zoom-out";
    IconName["PICTO_FACILITI"] = "tri-picto-faciliti";
    IconName["PICTO_HANDICAPZERO"] = "tri-picto-handicapzero";
    IconName["PICTO_LA_FIBRE"] = "tri-picto-la-fibre";
    IconName["PICTO_MABB"] = "tri-picto-mabb";
    IconName["PICTO_PAYMENT_AMERICANEXPRESS"] = "tri-picto-payment-americanexpress";
    IconName["PICTO_PAYMENT_CB"] = "tri-picto-payment-cb";
    IconName["PICTO_PAYMENT_MASTERCARD"] = "tri-picto-payment-mastercard";
    IconName["PICTO_PAYMENT_PAYPAL"] = "tri-picto-payment-paypal";
    IconName["PICTO_PAYMENT_VISA"] = "tri-picto-payment-visa";
})(IconName || (IconName = {}));
